import React from 'react';

import {useAllArtist, useActiveArtist} from 'hooks/UserHook';
import SetoCanvasPage from 'pages/SetoCanvasPage';
import {A, Title} from 'views/AppElements';
import ArtistSlider, {ArtistAvatar} from 'views/designer/ArtistSlider';

import {Separator} from 'views/AppElements';
const ALPHABETS = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", 
                    "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];

const AllArtistPage = (props) => {
    const urlPrefix = props.match.params.prefix;
    const prefix = urlPrefix? urlPrefix: 'A';
    
    const browseLetters = ALPHABETS.map(a => <A key={"letter_"+a} className={prefix === a? 'activeLetter': ''} href={"/artist/browse/"+a}>{a}</A>);

    const allArtists = useAllArtist(prefix.toUpperCase());
    let avatars = null;

    if(allArtists !== null && allArtists.size > 0) {
        avatars = allArtists.map(user => <div className="artistAvatarContainer" key={"EachArtist_"+user.username+"_"+user.id}><ArtistAvatar user={user} /></div>);
    } else if(allArtists === null) {
        avatars = [1,2,3].map(i => <div className="artistAvatarContainer" key={"ArtistContainerLoader_"+i}><ArtistAvatar user={null} /></div>);
    } else if (allArtists.size === 0) {
        avatars = <h1 style={{textAlign: "center", color: "gray", width: '100%', alignSelf: 'center'}}><i className="fa fa-cloud" aria-hidden="true" style={{color: "#949699"}}></i> No Artists Found</h1>
    }
    
    const activeArtist = useActiveArtist();
    return (
        <SetoCanvasPage id="allArtistPage" title={"Nepals' Creative Artists Premium Hub | Seto Canvas"} metaDescription={"Get your favourite artist merch, T-shirt, Hoodies and all kinds of merchandise at SetoCanvas.com"}>
            <Title title="BROWSE ARTISTS" />
            <div id="browseLetters" className="flexRow">
                {browseLetters}
            </div>
            <Separator />

            <div id="browseArtists" className="flexRow" style={{margin: '20px 0'}}>
                {avatars}
            </div>

            <ArtistSlider users={activeArtist} />
        </SetoCanvasPage>
    );
};

export default AllArtistPage;


// WEBPACK FOOTER //
// ./src/pages/AllArtistPage.js